<template>
  <div>
    <heading>{{ $t("proof.title") }}</heading>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs"></v-breadcrumbs>
    <proofTable ref="proofTable" />
  </div>
</template>

<script>
import proofTable from "./proofTable.vue";
import i18n from "../../i18n";

export default {
  name: "proofs",
  components: { proofTable },
  computed: {
    breadcrumbs() {
      return [
        {
          text: i18n.t("proof.category.title"),
          disabled: false,
          href: `/app/proofCategory`,
        },
        {
          text: this.$route.params.proofCategoryName,
          disabled: true,
        },
      ];
    },
  },
};
</script>
